import { Flex } from '@skin-seoul/design-system';
import { motion } from 'motion/react';
import { ANIMATION_DURATION } from '../constants/animation';
import { amazonColors } from '../constants/colors';
const BUTTON_SIZE = 48;
const MotionButton = motion.create(Flex);

// Arrow Icons
const ArrowLeftIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="ArrowLeftIcon" data-sentry-source-file="CenterButton.tsx">
    <path d="M21 5L21 19" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
    <path d="M11 18L17 12L11 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
    <path d="M17 12L3 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
  </svg>;
const ArrowRightIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="ArrowRightIcon" data-sentry-source-file="CenterButton.tsx">
    <path d="M3 5L3 19" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
    <path d="M13 18L7 12L13 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
    <path d="M7 12L21 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CenterButton.tsx" />
  </svg>;
interface CenterButtonProps {
  hoveredSection: 'left' | 'right' | null;
  expandedSection: 'left' | 'right' | null;
  hasExpanded: boolean;
  onClick: () => void;
}
const CenterButton = ({
  hoveredSection,
  expandedSection,
  hasExpanded,
  onClick
}: CenterButtonProps) => {
  const getPosition = () => {
    if (expandedSection === null) {
      return '50%';
    }
    if (expandedSection === 'left') {
      return '100%';
    } else if (expandedSection === 'right') {
      return '0%';
    }
    return '50%';
  };
  const getBackgroundColor = () => {
    if (expandedSection) {
      if (expandedSection === 'left') {
        return 'primary.500';
      } else {
        return amazonColors.prime.blue;
      }
    }
    return hoveredSection === 'left' ? amazonColors.prime.blue : 'primary.500';
  };
  const getArrowIcon = () => {
    if (expandedSection) {
      return expandedSection === 'right' ? <ArrowLeftIcon /> : <ArrowRightIcon />;
    }
    return hoveredSection === 'right' ? <ArrowRightIcon data-sentry-element="ArrowRightIcon" data-sentry-component="getArrowIcon" data-sentry-source-file="CenterButton.tsx" /> : <ArrowLeftIcon data-sentry-element="ArrowLeftIcon" data-sentry-component="getArrowIcon" data-sentry-source-file="CenterButton.tsx" />;
  };
  if (hoveredSection === null && !hasExpanded) {
    return null;
  }
  return <MotionButton onClick={onClick} as="button" position="absolute" top="50%" left="50%" background={getBackgroundColor()} border="none" borderRadius="50%" width={`${BUTTON_SIZE}px`} height={`${BUTTON_SIZE}px`} minWidth={`${BUTTON_SIZE}px`} alignItems="center" justifyContent="center" cursor="pointer" zIndex={3} initial={{
    transform: 'translate(-50%, -50%)'
  }} animate={{
    left: getPosition(),
    transform: 'translate(-50%, -50%)'
  }} transition={{
    duration: ANIMATION_DURATION,
    ease: 'easeInOut'
  }} data-sentry-element="MotionButton" data-sentry-component="CenterButton" data-sentry-source-file="CenterButton.tsx">
      <motion.div data-sentry-element="motion.div" data-sentry-source-file="CenterButton.tsx">{getArrowIcon()}</motion.div>
    </MotionButton>;
};
export default CenterButton;